import React, { useState, useEffect } from 'react'
import { getMUICache, getImageId, getImageUrl, getImageSize, getImageCreditString } from "../../../common/utils"
import { CacheProvider } from '@emotion/react';
import slideShowStyles from './SlideShowTwo.css'
import { Grid, Typography, Button } from '@mui/material';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

const Slide = (props) => {
    const cache = getMUICache();
    const { item, maxlength, currentIndex, showNewsAgency, isViewport, showImageCredits,imagecroptype} = props;
    console.log(`Slide show theme-two is using imagecroptype: ${imagecroptype}. (Prop was: ${props.imagecroptype})`);
    const { id } = item;
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();
    useEffect(()=>{
        EagerLoadImages()
    },[]);

    return (
        <React.Fragment>
            <CacheProvider value={cache}>
                <Grid className='story-box'>
                    <div className="slideshow-summary">
                        <strong class="counter"><span className='ctindex'>{currentIndex}</span> <span class="result">{maxlength}</span></strong> <span className='largescreen'>{item.hl}</span>
                    </div>
                    <div className="card-box img-box">
                        {/* {getImageSize(item.imageid) && <img width="616" height="315" alt="image" src={getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 616, undefined, item.pubInfo.baseDomain, false,  props.CONSTANTS)} />} */}
                        {
                            getImageSize(item.imageid) && <picture>
                                {/* Add multiple source elements for different image sources */}
                                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 760, 428, item.pubInfo.baseDomain, false, props.CONSTANTS, imagecroptype)} />

                                <source media="(max-width: 768px)" srcSet={getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 328, 185, item.pubInfo.baseDomain, false, props.CONSTANTS, imagecroptype)} />
                                {/* Fallback image for browsers that do not support the picture element */}

                                {isViewport ? (<img  alt={(item?.metaInfo?.Alttitle ? item.metaInfo.Alttitle : item?.hl)?.slice(0, 25)} title={item.hl?.slice(0, 25)} loading="lazy"/>)
                                    : (<img  alt={(item?.metaInfo?.Alttitle ? item.metaInfo.Alttitle : item?.hl)?.slice(0, 25)} title={item.hl?.slice(0, 25)} loading="lazy"/>)}
                            </picture>
                        }
                    </div>

                    <div className='commonImagecreditMainWrapper'>
                        {/* <div className='commonImageCeditTitle'> {item.metaInfo.TheCaptionOfTheImage}</div> */}
                        {showImageCredits && item && getImageSize(item.imageid) && <div className='commonImageCeditAgencyAuth'>{getImageCreditString(item.ag, item.au, item.metaInfo?.ImageCreditSourceName, item.pubInfo?.channel)}</div>}
                    </div>

                    {/* {showNewsAgency && <div className="card-box img-credit">
                        Photo:<span>{item.ag}</span>
                    </div>} */}
                    <div className="card-box as-content-body">
                        <Typography>
                            {item.syn}
                        </Typography>
                    </div>
                </Grid>

            </CacheProvider>
        </React.Fragment>
    )
}

export default Slide;